__turbopack_context__.v({
  "card": "styles-module-scss-module__Slt5Pa__card",
  "card-container": "styles-module-scss-module__Slt5Pa__card-container",
  "card-number": "styles-module-scss-module__Slt5Pa__card-number",
  "cards": "styles-module-scss-module__Slt5Pa__cards",
  "component": "styles-module-scss-module__Slt5Pa__component",
  "container": "styles-module-scss-module__Slt5Pa__container",
  "content-container": "styles-module-scss-module__Slt5Pa__content-container",
  "desktop": "styles-module-scss-module__Slt5Pa__desktop",
  "image-container": "styles-module-scss-module__Slt5Pa__image-container",
  "indicator": "styles-module-scss-module__Slt5Pa__indicator",
  "indicators": "styles-module-scss-module__Slt5Pa__indicators",
  "mobile": "styles-module-scss-module__Slt5Pa__mobile",
  "mobile-card": "styles-module-scss-module__Slt5Pa__mobile-card",
  "mobile-cards": "styles-module-scss-module__Slt5Pa__mobile-cards",
});
